import React from "react";

import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import ViewAddressIndex from "../../../components/SidetabPages/Customers/ViewAddressIndex";

const ViewAddress = () => {
  return (
    <>
      <AnnouncementBar />
      <ViewAddressIndex />
    </>
  );
};
export default ViewAddress;
